import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import ChangePasswordView from 'views/security/adminuser/configuration/changePassword/changePasswordView'; // Importing ChangePasswordView component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the change password agent list view.
 * @extends JetView
 */
export default class changePasswordAgentListView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The layout configuration for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applying theme to the toolbar
                    elements: [
                        {
                            view: 'label', // Label component
                            label: _('Cambiar Contraseña'), // Translated label text
                            width: 300, // Width of the label
                        },
                    ],
                },
                ChangePasswordView, // Including ChangePasswordView in the layout
            ],
        };
        webix.ui.fullScreen(); // Setting the UI to full screen mode
        if (
            !devConfig.getPermAction(
                // Checking permissions for the action
                'AdminuserConfigurationChangePasswordMenu',
                'Menu',
            )
        ) {
            this.show('./security.adminuser.configuration.generateToken'); // Redirecting if permission is denied
        } else {
            return {
                type: 'wide', // Setting layout type to wide
                cols: [left], // Defining columns with the left layout
            };
        }
    }
}

// FILE DOCUMENTED
